// eslint-disable-next-line
export default {
    state: {
        collections: []
    },
    setCollectionsAction: function(state, action) {
        state.collections = action
    },
}